import React, { Dispatch, SetStateAction } from 'react';
import moment from 'moment';

import { Star, X } from 'lucide-react';

import { useGetFeedbacksForCompleteData } from '../../../hooks/feedback';
import { useGetV2FeedbacksForCompleteData } from '../../../hooks/v2_feedback';

interface FeedbacksProps {
    open: boolean;
    sessionId: string | null;
    setFeedbackViewData: Dispatch<SetStateAction<{ sessionId: string } | null>>;
};
export const FeedbacksView = (props: FeedbacksProps) => {
    const { open, sessionId, setFeedbackViewData } = props;

    const { data: feedbacksV1, isLoading: isFeedbacksV1Loading } = useGetFeedbacksForCompleteData(sessionId);
    const { data: feedbacksV2, isLoading: isFeedbacksV2Loading } = useGetV2FeedbacksForCompleteData(sessionId);

    return (
        <div className={`complete_data__feedbacks ${open ? 'complete_data__feedbacks--open' : ''}`}>
            <div className='card card--md complete_data__feedbacks__content'>
                <div className='complete_data__feedbacks__header'>
                    <p className='text-lg text-bold'>Feedbacks for Session</p>
                    <button
                        className='complete_data__feedbacks__header__close_btn'
                        onClick={() => setFeedbackViewData(null)}
                    >
                        <X />
                    </button>
                </div>
                {(isFeedbacksV1Loading || isFeedbacksV2Loading) && (
                    <div className='d-flex flex-column gap-sm justify-content-center align-items-center'>
                        <div className='list-loader' />
                        <p className='text-semibold'>Loading Feedbacks</p>
                    </div>
                )}
                {!isFeedbacksV1Loading && !isFeedbacksV2Loading && !feedbacksV1?.length && !feedbacksV2?.length && (
                    <div className='d-flex flex-column gap-sm justify-content-center align-items-center'>
                        <p className='text-semibold'>No feedbacks yet!</p>
                    </div>
                )}
                {!isFeedbacksV1Loading && !isFeedbacksV2Loading && !!feedbacksV1?.length && (
                    <div className='complete_data__feedbacks__v1_list'>
                        {feedbacksV1.map((feedback) => (
                            <div
                                key={feedback.id}
                                className='complete_data__feedbacks__v1_list__feedback'
                            >
                                <p className='text-semibold'>{moment(feedback.created_at).format('MMM DD, YYYY')}</p>
                                <div className='complete_data__feedbacks__v1_list__feedback__star_rating'>
                                    {Array.from({ length: 5 }, (_, index) => (
                                        <Star key={index} className={`complete_data__feedbacks__v1_list__feedback__star_rating__star ${feedback.rating >= index + 1 ? 'complete_data__feedbacks__v1_list__feedback__star_rating__star--filled' : ''}`} />
                                    ))}
                                </div>
                                <p className='text-sm color--gray-700'>{feedback.improvement_suggestion}</p>
                            </div>
                        ))}
                    </div>
                )}
                {!isFeedbacksV1Loading && !isFeedbacksV2Loading && !!feedbacksV2?.length && (
                    <div className='complete_data__feedbacks__v2_list'>
                        {feedbacksV2.map((feedback) => (
                            <div
                                key={feedback.id}
                                className='complete_data__feedbacks__v2_list__feedback'
                            >
                                <p className='text-semibold'>{moment(feedback.created_at).format('MMM DD, YYYY')}</p>
                                <div className='complete_data__feedbacks__v2_list__feedback__responses'>
                                    {feedback.responses.map((response, idx) => (
                                        <p key={idx} className='text-sm color--gray-600'>
                                            {response.question} - <span className='color--gray-800'>{response.rating}</span>
                                        </p>
                                    ))}
                                </div>
                                {feedback.improvement && <p className='text-sm color--gray-700 mt-md'>
                                    <span className='text-semibold'>Suggestion: </span>{feedback.improvement}
                                </p>}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};